import * as actionTypes from 'requests/actionTypes';
import {parseJsonApiRepresentation} from 'requests/responseHandlers/2xx';
import {queueRequests} from 'requests/actions';
import {POST} from 'requests';

function imageFromDropzone(request, record, dropzoneInstance, requireFile) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.REQUEST_QUEUED,
      request,
    });

    if (dropzoneInstance.files.length === 0 && requireFile) {
      dispatch({
        type: actionTypes.RESPONSE_BAD_REQUEST,
        response: new Response('', {status: 400}),
        request,
        errors: {image: ['is required']},
      });
    } else  {
      const dropzoneNeedsProcessing = (dropzoneInstance.files.length === 1 && !dropzoneInstance.files[0].complete);

      if (!dropzoneNeedsProcessing) {
        queueRequests([request])(dispatch);
      } else {
        dropzoneInstance.on('success', (file, json) => {
          queueRequests([request])(dispatch);
        });

        dropzoneInstance.on('error', (file, json, xhr) => {
          dropzoneInstance.removeAllFiles(true);

          dispatch({
            type: actionTypes.RESPONSE_FAILURE,
            response: new Response('', {status: 500}),
            request,
          });
        });

        dropzoneInstance.processQueue();
      }
    }
  };
}

export function createImageFromDropzone(request, record, dropzoneInstance) {
  return imageFromDropzone(request, record, dropzoneInstance, true);
}

export function updateImageFromDropzone(request, record, dropzoneInstance) {
  return imageFromDropzone(request, record, dropzoneInstance, false);
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/actions/workingSetImages.js